export const SET_USERS_LIST = "usermanagement/SET_USERS_LIST";
export const APPEND_USERS_LIST = "usermanagement/APPEND_USERS_LIST";
export const DELETE_USER = "usermanagement/DELETE_USER";
export const UPDATE_USER_ID = "usermanagement/UPDATE_USER_ID"